import React from "react";
import submit from "submit-form";
import { useTranslation } from "react-i18next";

export const ReportsBackHandler = ({ title, locals, customBackUrl }) => {
  const { t } = useTranslation("common");
  const handleBack = (e) => {
    if (locals?.query?.bodycomp) {
      e.preventDefault();
      history.back();
      //     submit("/actions/refresh", {
      //       method: "GET",
      //     });
    }
  };
  return (
    <a
      className="only-show-mobile"
      role="reports-back-handler"
      href={
        customBackUrl ||
        `/athlete-portal/metrics/reports-menu?athlete=${locals?.athlete?._id}`
      }
      onClick={handleBack}
    >
      <img src="/img/new-icons/arrow-left.svg" alt={t("back")} />
      <span>{title}</span>
    </a>
  );
};
